import { BlockModel } from '../../../../Common/PageBuilder/models/block.model';
import { ChartDisplayElementModel } from '../../../../Common/Reports/models/chart-display-element.model';
import { ReportBlockTypeEnum } from '../../../../Common/Reports/enums/report-block-type.enum';


export function sharedReportDataFromNoVersionToOnePointOh(block: BlockModel, chartData: any): BlockModel {
    let dataProvider, data;

    switch (block.type.key) {
        case ReportBlockTypeEnum.COVERAGE_OVER_TIME:
            dataProvider = (block.displayElement as ChartDisplayElementModel).series[0].dataProvider;
            data = dataProvider.getValue();
            const metrics = chartData.metrics;
            data.forEach(dataPoint => {
                metrics.forEach((metric, index) => {
                    const value = dataPoint['yValue_' + metric];
                    dataPoint['yValue' + index] = value;
                });
            });
            break;
        case ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME:
        case ReportBlockTypeEnum.TOP_10_OUTLETS:
        case ReportBlockTypeEnum.TOP_HASHTAGS:
            dataProvider = (block.displayElement as ChartDisplayElementModel).series[0].dataProvider;
            data = dataProvider.getValue();
            data.forEach(dataPoint => {
                dataPoint['value0'] = dataPoint['xValue'];
            });
            break;
    }

    block['version'] = '1.0';
    return block;
}
